import { render, staticRenderFns } from "./EditorBlockFileList.vue?vue&type=template&id=1c6d99c0&scoped=true"
import script from "./EditorBlockFileList.vue?vue&type=script&lang=js"
export * from "./EditorBlockFileList.vue?vue&type=script&lang=js"
import style0 from "./EditorBlockFileList.vue?vue&type=style&index=0&id=1c6d99c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6d99c0",
  null
  
)

export default component.exports